// Module
var code = `<!-- Create Interval Modal -->
<!-- The .modal element acts as the backdrop (same pattern as main calendar modal) -->
<div class="modal fade z-index-modal-nested nested-modal-backdrop" ng-class="{'show': \$ctrl.show}"
  ng-style="{'display': \$ctrl.show ? 'block' : 'none'}" ng-click="\$ctrl.cancel()" tabindex="-1" role="dialog"
  aria-labelledby="createIntervalModalLabel" ng-attr-aria-hidden="{{!\$ctrl.show}}" ng-show="\$ctrl.localInterval">
  <div class="modal-dialog modal-xl" role="document" ng-click="\$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="createIntervalModalLabel">
          <i class="fas fa-plus-circle"></i> Create New Interval
        </h5>
        <button type="button" class="btn-close" ng-click="\$ctrl.cancel()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div ng-show="\$ctrl.localInterval" class="create-interval-form">
          <!-- 2-Column Layout -->
          <div class="row">
            <!-- Left Column: Playlist Selection -->
            <div class="col-md-8">
              <div class="mb-3">
                <label class="form-label">
                  <i class="fas fa-list"></i> Select Playlist (Scene Collection) </label>
                <div class="input-group input-group-sm mb-2">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                  <input type="text" class="form-control" ng-model="\$ctrl.playlistSearch"
                    placeholder="Søg efter playlist...">
                  <button class="btn btn-outline-secondary" type="button" ng-show="\$ctrl.playlistSearch"
                    ng-click="\$ctrl.playlistSearch = ''">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                <div class="playlist-selection-list border rounded p-2 bg-secondary">
                  <div ng-if="\$ctrl.availablePlaylists.length === 0" class="text-muted text-center py-4">
                    <i class="fas fa-info-circle"></i> No playlists available for this scene
                  </div>
                  <div ng-repeat="collection in \$ctrl.availablePlaylists | filter:{name: \$ctrl.playlistSearch}"
                    class="playlist-item p-3 mb-2 border rounded cursor-pointer"
                    ng-class="{'bg-primary text-white': \$ctrl.localInterval.selectedSceneCollectionId == collection.id, 'bg-light': \$ctrl.localInterval.selectedSceneCollectionId != collection.id}"
                    ng-click="\$ctrl.localInterval.selectedSceneCollectionId = collection.id" role="button" tabindex="0"
                    ng-keydown="\$event.keyCode === 13 && (\$ctrl.localInterval.selectedSceneCollectionId = collection.id)">
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="flex-grow-1">
                        <h6 class="mb-1"
                          ng-class="{'text-white': \$ctrl.localInterval.selectedSceneCollectionId == collection.id}">
                          <i class="fas fa-play-circle me-2"></i>{{collection.name}}
                        </h6>
                        <small
                          ng-class="{'text-white-50': \$ctrl.localInterval.selectedSceneCollectionId == collection.id, 'text-muted': \$ctrl.localInterval.selectedSceneCollectionId != collection.id}">
                          <span ng-if="collection.intervals && collection.intervals.length > 0">
                            <i class="fas fa-calendar-alt me-1"></i>{{collection.intervals.length}} scheduled
                            interval<span ng-if="collection.intervals.length !== 1">s</span>
                          </span>
                          <span ng-if="!collection.intervals || collection.intervals.length === 0">
                            <i class="fas fa-clock me-1"></i>No scheduled intervals </span>
                        </small>
                      </div>
                      <div ng-show="\$ctrl.localInterval.selectedSceneCollectionId == collection.id" class="ms-2">
                        <i class="fas fa-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Right Column: Time Range & Priority -->
            <div class="col-md-4">
              <!-- Time Range Display -->
              <div class="mb-3">
                <div class="card bg-info text-white">
                  <div class="card-body">
                    <h6 class="card-title mb-2">
                      <i class="fas fa-clock me-2"></i>Selected Time Range
                    </h6>
                    <div class="mb-2">
                      <strong>{{\$ctrl.formatDateTime(\$ctrl.localInterval.startTime, 'ddd, MMM DD - HH:mm')}} →
                        {{\$ctrl.formatDateTime(\$ctrl.localInterval.endTime, 'HH:mm')}}</strong>
                    </div>
                    <small>Duration: {{\$ctrl.localInterval.duration}} minutes</small>
                  </div>
                </div>
              </div>
              <!-- Priority -->
              <div class="mb-3">
                <label for="create-priority" class="form-label">
                  <i class="fas fa-sort-numeric-up"></i> Priority </label>
                <input type="number" id="create-priority" class="form-control" ng-model="\$ctrl.localInterval.priority"
                  min="1" max="1000" required />
                <div class="form-text">
                  <small>Higher numbers = higher priority. Default: 100</small>
                </div>
              </div>
              <!-- Selection Status -->
              <div class="mb-3">
                <div class="card"
                  ng-class="{'border-success bg-light-success': \$ctrl.localInterval.selectedSceneCollectionId, 'border-warning bg-light-warning': !\$ctrl.localInterval.selectedSceneCollectionId}">
                  <div class="card-body p-3">
                    <div ng-if="\$ctrl.localInterval.selectedSceneCollectionId" class="text-success">
                      <i class="fas fa-check-circle me-2"></i>
                      <strong>Ready to create!</strong>
                      <div class="mt-1">
                        <small ng-repeat="collection in \$ctrl.availablePlaylists"
                          ng-if="collection.id == \$ctrl.localInterval.selectedSceneCollectionId"> Playlist:
                          <strong>{{collection.name}}</strong>
                        </small>
                      </div>
                    </div>
                    <div ng-if="!\$ctrl.localInterval.selectedSceneCollectionId" class="text-danger">
                      <i class="fas fa-exclamation-triangle me-2"></i>
                      <strong>Please select a playlist</strong>
                      <div class="mt-1">
                        <small>Choose a playlist from the left to continue</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Loading State -->
        <div ng-show="!\$ctrl.localInterval" class="text-center py-3">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading playlists...</span>
          </div>
          <p class="mt-2">Loading available playlists...</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" ng-click="\$ctrl.cancel()">
          <i class="fas fa-times"></i> Cancel </button>
        <button type="button" class="btn btn-primary" ng-click="\$ctrl.create()"
          ng-disabled="!\$ctrl.localInterval || !\$ctrl.localInterval.selectedSceneCollectionId">
          <i class="fas fa-save"></i> Create Interval </button>
      </div>
    </div>
  </div>
</div>`;
// Exports
export default code;